import SubText from "components/shared/SubText";
import "swiper/css/navigation";
import "swiper/css";
import CreatorVideoCard from "./CreatorVideoCard";
import CreatorVideoSkeleton from "components/skeleton/CreatorVideoSkeleton";
import NoSearch from "pages/searchPage/shared/NoSearch";

function CreatorHomeVideoGrid({
  creatorData,
  isLoading,
  handleCreatorVideoShowMore,
}: any) {
  const recent_videos = creatorData?.recent_videos || [];
  return (
    <div>
      {!isLoading && (
        <>
          {recent_videos.length !== 0 && recent_videos && (
            <>
              <div className="mt-10 ml-3 flex justify-between max-sm:ml-0">
                <SubText text="Videos" className="font-bold" />
                {recent_videos?.length > 5 && (
                  <p
                    className="mr-10 cursor-pointer text-[14px] font-[500] text-[#F50537] max-sm:mr-3"
                    onClick={handleCreatorVideoShowMore}
                  >
                    See All
                  </p>
                )}
              </div>
              <div className="mb-5 mt-4 grid w-[95%] grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 max-sm:w-full">
                {recent_videos?.slice(0, 5).map((video: any, index: any) => (
                  <CreatorVideoCard
                    key={index}
                    video={{
                      ...video,
                      creator_name:
                        video?.creator_name || creatorData?.general_info?.name,
                    }}
                    slug={creatorData?.general_info.slug}
                    isLoading={isLoading}
                  />
                ))}
              </div>
            </>
          )}
        </>
      )}
      {isLoading && <CreatorVideoSkeleton />}
    </div>
  );
}

export default CreatorHomeVideoGrid;
